<div class="modal fade custom-modal-width" id="identifyMeasurementModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'identify' | transloco }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body p-0">
        <div>
          @if(selectedPatient){
          <div class="m-3">
            <app-patient-about-short [patientId]="selectedPatient.id"></app-patient-about-short>
          </div>
          <adl-table
            [loading]="isLoading"
            [tableData]="patientCards"
            [columnHeader]="columnHeaderPatientCard"
            [paginationInfo]="patientCardsPaginated"
            (rowClick)="selectCard($event)"
            (configChange)="setConfig($event)"
            [tableTitle]="'select_patient_card' | transloco"
          ></adl-table
          >}
        </div>

        <div [hidden]="selectedPatient">
          <app-identify-patient-list (patientSelected)="selectPatient($event)"></app-identify-patient-list>
        </div>
      </div>
      <div class="modal-footer">
        @if(selectedPatient) {
        <button class="btn btn-outline-warning" (click)="goBackToPatientSelect()">
          {{ 'change_patient' | transloco }}
        </button>
        }
        <button class="btn btn-outline-secondary" (click)="closeModal()">
          {{ 'cancel' | transloco }}
        </button>
      </div>
    </div>
  </div>
</div>
